module.exports = __webpack_public_path__ + "curriculum-05.png?59a2768eae70442d8aa2a26f0b618b7e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/curriculum-05.png
// module id = 218
// module chunks = 0